
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { isMobile, isTablet } from "mobile-device-detect";
import LazyImage from "./../LazyImage.vue";
import Slick from "vue-slick";
import { apiFetchAminityInfo } from "../../api";
import { LotPosition, AmenityInfo, Amenity } from "./../../types";
import { Scalers } from "./../../constant";
import LeftArrowIcon from "@/assets/icons/LeftArrow.vue";
import {
  addImageScaler,
  calcZoom,
  getPlatMapModalPosition,
  getPlatMapModalPositionMobile,
  getTouchesCenter,
  getZoomDistance,
} from "./../../core";
@Component({
  components: {
    LazyImage,
    Slick,
    LeftArrowIcon
  },
})
export default class PlatmapAmenityModal extends Vue {
  $refs!: any;
  sliderOptions: any = {
    slidesToShow: 1,
    infinite: false,
  };
  private amenityTitle = "";
  private amenityCaption = "";
  private hasMobile = !!(isMobile && !isTablet);
  private hasTablet = isTablet;
  private amenityInfo: AmenityInfo = {} as AmenityInfo;
  private loading = true;
  private lotPosition: LotPosition = {} as LotPosition;
  private nextAmenityName = "";

  private zoom = 1;
  private zoomCenter = {
    x: 0,
    y: 0,
  };
  private lastDistance = 0;
  private minZoomBounce = 0.015;
  private maxZoomBounce = 0.015;
  private width = window.innerWidth;
  private height = window.innerHeight;
  private lastX = null as any;
  private lastY = null as any;
  private x = 0;
  private y = 0;
  private transition = {
    transform: null as any,
    origin: "transform-origin 400ms linear" as any,
  };
  private minZoom = 1;
  private maxZoom = 10;
  private speed = 0.5;

  @Prop() private position!: LotPosition;
  @Prop() private amenityId!: string;
  @Prop() private underlay!: boolean;
  @Prop() private amenities!: Array<string>;
  @Prop() private allAmenities!: Array<Amenity>;
  @Prop() private isKioskMode!: boolean;
  @Prop() private zoomLevel!: number;
  @Emit("closeAmenityInfo") closeAmenityInfo() {}
  @Emit("updateLotPosition") updateLotPosition(lotPosition: LotPosition) {}
  @Emit("setAminityId") setAminityId(amenityId: string) {}
  @Emit("setMapCenter") setMapCenter(x: number, y: number) {}

  @Watch("amenityId")
  onLotIdChanged(val: string, oldVal: string) {
    if (val !== oldVal) {
      this.resetZoom()
      this.fetchAmenityInfo(val);
    }
  }

  @Watch("position")
  handlePositionChange(val: LotPosition, oldVal: LotPosition) {
    if (!this.lodash.isEqual(val, oldVal)) {
      this.lotPosition = val;
    }
  }

  mounted() {
    this.lotPosition = this.position;
    this.fetchAmenityInfo(this.amenityId);
  }

  handleReInit() {
    this.$nextTick(() => {
      this.$refs.slick.reSlick();
    });
  }
  beforeAmenityClose() {
    this.amenityInfo = {} as AmenityInfo;
    let timer = setTimeout((_) => {
      this.closeAmenityInfo();
      clearTimeout(timer);
    }, 10);
  }
  updated() {
    this.$nextTick(function () {
      // if (!isMobile && !isTablet)
      this.updateModalPosition();
    });
  }
  beforeDestroy() {
    const el = this.$refs.baseElement;
    if(el) {
      el.removeEventListener('touchstart', this.start)
      el.removeEventListener('touchmove', this.move)
      el.removeEventListener('touchend', this.end)
    }
  }

  bottomArrowCondition(xPosition: string, yPosition: string) {
    return (
      !this.lodash.isEmpty(this.lotPosition) &&
      !!(
        this.lotPosition.xPosition === xPosition &&
        this.lotPosition.yPosition === yPosition
      )
    );
  }
  loadNextAmenityName() {
    let currentIndex = this.amenities.indexOf(this.amenityId);
    const nextIndex = ++currentIndex % this.amenities.length;
    const amenityId = this.amenities[nextIndex];
    const nextAminity = this.allAmenities.filter((x) => x.id === amenityId);
    if (nextAminity.length) this.nextAmenityName = nextAminity[0].title;
    else this.nextAmenityName = "";
  }

  loadNewAmenity() {
    let currentIndex = this.amenities.indexOf(this.amenityId);
    const nextIndex = ++currentIndex % this.amenities.length;
    const amenityId = this.amenities[nextIndex];
    if (this.underlay) {
      this.movePlatmapWithMap(amenityId);
    } else {
      this.movePlatmapWithoutMap(amenityId);
    }
    this.setAminityId(amenityId);
  }

  movePlatmapWithoutMap(amenityId: string) {
    const amenityElement = document.getElementById(amenityId) as HTMLElement;
    if (amenityElement) {
      const amenityElementPosition = amenityElement.getBoundingClientRect();
      const modalWidth = 364;
      let overlayContainer = document.getElementById("plan-svg") as HTMLElement;
      const containerTop = parseFloat(
        overlayContainer.style.top.replace("px", "")
      );
      const containerLeft = parseFloat(
        overlayContainer.style.left.replace("px", "")
      );
      const topPosition = -(
        amenityElementPosition.y -
        (containerTop + window.innerHeight / 2)
      );
      let leftPosition = -(amenityElementPosition.x - containerLeft);
      if (isMobile) {
        if (leftPosition < window.innerWidth / 2) {
          leftPosition += window.innerWidth / 2;
        }
        if (leftPosition > window.innerWidth) {
          leftPosition = window.innerWidth;
        }
      } else {
        if (leftPosition < window.innerWidth / 2 + modalWidth) {
          leftPosition += window.innerWidth / 2 + modalWidth;
        }
        if (leftPosition > window.innerWidth) {
          leftPosition = window.innerWidth;
        }
      }

      overlayContainer.style.left = `${leftPosition}px`;
      overlayContainer.style.top = `${topPosition}px`;
    }
  }

  movePlatmapWithMap(amenityId: string) {
    const amenityElement = document.getElementById(amenityId) as HTMLElement;
    if (amenityElement) {
      const amenityElementPosition = amenityElement.getBoundingClientRect();
      this.setMapCenter(amenityElementPosition.x, amenityElementPosition.y);
    }
  }

  updateModalPosition() {
    let lotElement = document.getElementById(this.amenityId) as HTMLElement;
    if (lotElement) {
      const modelContainer = document.getElementById(
        "amenity-modal"
      ) as HTMLElement;
      let elementPosition = lotElement.getBoundingClientRect();
      const lotPosition =
        isMobile || isTablet
          ? getPlatMapModalPositionMobile(elementPosition)
          : getPlatMapModalPosition(
              elementPosition,
              modelContainer.clientHeight,
              this.zoomLevel
            );
      if (!this.lodash.isEqual(this.lotPosition, lotPosition)) {
        this.updateLotPosition(lotPosition);
      }
    }
  }
  resetAmenityInfo() {
    this.amenityTitle = "";
    this.amenityCaption = "";
    this.amenityInfo = {} as AmenityInfo;
  }
  setAmenityTitleAndCaption() {
    for (const [key, value] of Object.entries(this.amenityInfo)) {
      if (!this.amenityTitle && value.title) this.amenityTitle = value.title;
      if (!this.amenityCaption && value.caption)
        this.amenityCaption = value.caption;
    }
  }
  addScaler(url) {
    return addImageScaler(url);
  }
  async fetchAmenityInfo(amenityId: string) {
    try {
      this.resetAmenityInfo();
      const data = await apiFetchAminityInfo(amenityId);
      const { result } = data;
      if (result.length) {
        this.amenityInfo = result as AmenityInfo;
        this.setAmenityTitleAndCaption();
      }
      this.loadNextAmenityName();
      this.loading = false;
    } catch (error) {
      this.amenityInfo = {} as AmenityInfo;
      this.loading = false;
    }
  }
  start(event) {
    // event.preventDefault();
    if (event.touches.length === 2) {
      this.handlePinchStart(event);
    }
  }
  handlePinchStart(event) {
    const { x, y } = this.getTouchCenter(
      getTouchesCenter(event.touches[0], event.touches[1])
    );
    if (this.zoom < this.maxZoom) {
      this.zoomCenter.x = x;
      this.zoomCenter.y = y;
    }
    this.lastDistance = getZoomDistance(
      event.touches[0],
      event.touches[1]
    );
  }
  getTouchCenter({ x, y }) {
    const rect = this.$refs.baseElement.getBoundingClientRect();
    return {
      x: x - rect.left,
      y: y - rect.top,
    };
  }
  move(event) {
    // event.preventDefault();
    if (event.touches.length === 2) {
      this.handlePinchMove(event);
    } else {
      this.handlePanMove(event);
    }
  }
  handlePinchMove(event) {
    const zoom = getZoomDistance(event.touches[0], event.touches[1]);
    const last = zoom / this.lastDistance;
    const scale = calcZoom(
      this.minZoom - this.minZoomBounce,
      this.maxZoom + this.maxZoomBounce,
      this.zoom * last
    );
    if (
      this.zoom < this.maxZoom ||
      (this.zoom >= this.maxZoom && scale < this.zoom)
    ) {
      this.zoom = scale;
    }
    this.lastDistance = zoom;
  }
  handlePanMove(event) {
    if (this.zoom > 1) {
      const touch = event.touches[0];
      const x = touch.clientX;
      const y = touch.clientY;
      if (!this.lastX || !this.lastY) {
        this.lastX = x;
        this.lastY = y;
        return null;
      } else {
        const rect = this.$refs.baseElement.getBoundingClientRect();
        let diffX = (x - this.lastX) * this.speed;
        let diffY = (y - this.lastY) * this.speed;
        this.transition.transform = null;
        //apply transform
        this.x += diffX;
        this.y += diffY;
        //bounds
        if (rect.left > 0 && diffX > 0) {
          this.x -= diffX;
        }
        if (rect.right < this.width && diffX < 0) {
          this.x -= diffX;
        }
        if (rect.top > 0 && diffY > 0) {
          this.y -= diffY;
        }
        if (rect.bottom < this.height && diffY < 0) {
          this.y -= diffY;
        }
        //to calc the next move
        this.lastX = x;
        this.lastY = y;
      }
    }
  }
  end(event) {
    // event.preventDefault();
    if (this.zoom <= this.minZoom) {
    this.resetZoom();
    } else {
      this.lastX = 0;
      this.lastY = 0;
    }
  }
  resetZoom() {
    this.zoom = 1;
    this.zoomCenter.x = 0;
    this.zoomCenter.y = 0;
    this.x = 0;
    this.y = 0;
  }
  get zoomStyles() {
    let transition = "";
    if (this.transition.transform) transition += this.transition.transform;
    if (this.transition.origin)
      transition +=
        (transition.length > 0 ? ", " : "") + this.transition.origin;
    return {
      transform: `scale(${this.zoom}) translate3d(${this.x}px, ${this.y}px, 0px)`,
      transition,
    };
  }
}
